
var validOpeningPermit = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传银行卡照片'));
    }
};
var validCardPositive = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传身份证正面照'));
    }
};
var validCardNegative = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传身份证反面照'));
    }
};
export default { // 验证
    nickname: [
        { required: true, message: '请填写代理商昵称', trigger: 'blur' },
    ],
    phone: [
        { required: true, message: '请填写代理商手机号', trigger: 'blur' },
    ],

    real_name: [
        { required: true, message: '请填写法人姓名', trigger: 'blur' },
    ],
    id_card: [
        { required: true, message: '请填写证件号', trigger: 'blur' },
    ],
    card_valid_sdate: [
        { required: true, message: '请选择身份证有效期', trigger: 'blur' },
    ],
    bank_id: [
        { required: true, message: '请选择银行名称', trigger: 'change' },
    ],
    bank_prov: [
        { required: true, message: '请选择银行归属地', trigger: 'change' },
    ],
    branch_bank_id: [
        { required: true, message: '请填写支行名称', trigger: 'change' },
    ],
    line_num: [
        { required: true, message: '请填写联行号', trigger: 'change' },
    ],
    bank_code: [
        { required: true, message: '请填写银行账号', trigger: 'blur' },
    ],
    bank_phone: [
        { required: true, message: '请填写银行卡预留手机号', trigger: 'blur' },
    ],
    opening_permit_img: [
        { required: true, validator: validOpeningPermit, trigger: 'change' },
    ],
    id_card_positive: [
        { required: true, validator: validCardPositive, trigger: 'change' },
    ],
    id_card_negative: [
        { required: true, validator: validCardNegative, trigger: 'change' },
    ]
}